// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jobs-index[data-v-38cb2c56]{background-color:#fff}@media screen and (min-width:560px){.swiper-tabs[data-v-38cb2c56]{padding-top:1.5rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
